import { senderBackSuppressErrorToast } from './sender-back-request';
import { api } from './http';

export interface SenderProfileSettings {
	landingDefaultBuildId?: string | null;
	autoRunDefaultCaption?: string;
	deviceDefaultBuildId?: string | null;
}

export interface SenderAuthJobSummary {
	id: string;
	source: 'landing' | 'device';
	status: string;
	phoneMasked: string;
	linkId?: string | null;
	clientId?: string | null;
	senderRunId?: string | null;
	createdAt: string;
	finishedAt?: string | null;
}

export interface SenderAuthJobDetail extends SenderAuthJobSummary {
	landingHostname?: string | null;
	buildId?: string | null;
	errorReason?: string | null;
	errorMessage?: string | null;
	codeType?: string | null;
}

export interface SenderAuthJobListResponse {
	items: SenderAuthJobSummary[];
}

export interface PanelSenderRunCreated {
	runId: string;
	dispatchStatus: 'queued';
}

export interface PanelSenderRunResumed {
	runId: string;
	dispatchStatus: 'queued';
}

export async function fetchSenderProfileSettings() {
	const { data } = await api.get<SenderProfileSettings>('/sender/profile-settings');
	return data;
}

export async function updateSenderProfileSettings(body: SenderProfileSettings) {
	const { data } = await api.put<SenderProfileSettings>(
		'/sender/profile-settings',
		body,
		senderBackSuppressErrorToast,
	);
	return data;
}

export async function fetchSenderAuthJobs(params?: { status?: string; limit?: number }) {
	const { data } = await api.get<SenderAuthJobListResponse>('/sender/auth-jobs', { params });
	return data;
}

export async function fetchSenderAuthJob(authJobId: string) {
	const { data } = await api.get<SenderAuthJobDetail>(`/sender/auth-jobs/${authJobId}`);
	return data;
}

export async function cancelSenderAuthJob(authJobId: string) {
	await api.post(`/sender/auth-jobs/${authJobId}/cancel`);
}

export async function createPanelSenderRun(form: FormData) {
	const { data } = await api.post<PanelSenderRunCreated>('/sender/runs', form, {
		headers: { 'Content-Type': 'multipart/form-data' },
		...senderBackSuppressErrorToast,
	});
	return data;
}

export async function resumePanelSenderRun(runId: string) {
	const { data } = await api.post<PanelSenderRunResumed>(`/sender/runs/${runId}/resume`);
	return data;
}
